import React from 'react';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
} from "reactstrap";

function Aviso(props) {
    return (
        <div>
            <Modal isOpen={props.isOpen}>
                <ModalBody>
                    { props.successMsg && (
                        <div className="alert alert-success alert-dismissible fade show" role="alert">{props.successMsg}</div>
                    )}
                    { props.errorMsg && (
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">{props.errorMsg}</div>
                    )}
                    { props.infoMsg && (
                        <div className="alert alert-info alert-dismissible fade show" role="alert">{props.infoMsg}</div>
                    )}
                    
                </ModalBody>

                <ModalFooter>
                    <Button
                    color="info"
                    onClick={props.onClose}
                    >
                    Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Aviso
